export enum UserScope {
  emailProfile = 'email profile'
}
